import React from 'react';
import ReactDOM from 'react-dom';
import Trial from "./Premium/trial";
import Order from "./Premium/order";
import Basket from "./Premium/basket";
import RecapitulationConfirm from "./Premium/Recapitulation/confirm";

const trialButtons = document.querySelectorAll('.premium-trial-button');
trialButtons.forEach(element => {
    ReactDOM.render(<Trial config={element?.dataset ?? {}}  />, element)
});

const order = document.getElementById('premium-order-card');

if (order) {
    ReactDOM.render(<Order config={order?.dataset ?? {}} />, order);
}

const basket = document.getElementById('premium-basket');

if (basket) {
    ReactDOM.render(<Basket config={basket?.dataset ?? {}} />, basket);
}

const recapitulationConfirm = document.getElementById('premium-recapitulation-confirm');

if (recapitulationConfirm) {
    ReactDOM.render(<RecapitulationConfirm config={recapitulationConfirm?.dataset ?? {}} />, recapitulationConfirm);
}
